import TutorApiUtils from '../utils/api/tutor';
import UserApiUtils from '../utils/api/user';

export const FETCH_TUTORS_SENT = 'FETCH_TUTORS_SENT';
export const FETCH_TUTORS_SUCCEEDED = 'FETCH_TUTORS_SUCCEEDED';
export const FETCH_TUTORS_FAILED = 'FETCH_TUTORS_FAILED';
export const FETCH_TUTOR_SENT = 'FETCH_TUTOR_SENT';
export const FETCH_TUTOR_SUCCEEDED = 'FETCH_TUTOR_SUCCEEDED';
export const FETCH_TUTOR_FAILED = 'FETCH_TUTOR_FAILED';
export const CLEAR_TUTOR_DATA = 'CLEAR_TUTOR_DATA';

export function clearTutorData() {
  return { type: CLEAR_TUTOR_DATA };
}

export function fetchSent() {
  return {
    type: FETCH_TUTORS_SENT,
  };
}

export function fetchSucceeded(data) {
  return {
    type: FETCH_TUTORS_SUCCEEDED,
    payload: data,
  };
}

export function fetchFailed(error) {
  return {
    type: FETCH_TUTORS_FAILED,
  };
}

export function fetchOneSent() {
  return {
    type: FETCH_TUTOR_SENT,
  };
}

export function fetchOneSucceeded(data) {
  return {
    type: FETCH_TUTOR_SUCCEEDED,
    payload: data,
  };
}

export function fetchOneFailed(error) {
  return {
    type: FETCH_TUTOR_FAILED,
    payload: error,
  };
}

export function fetch(timeZone) {
  return (dispatch) => {
    dispatch(fetchSent());
    return TutorApiUtils.fetch(timeZone).then(
      (data) => dispatch(fetchSucceeded(data)),
      (error) => dispatch(fetchFailed(error)),
    );
  };
}

export function fetchOne(idOrPermalink) {
  return (dispatch) => {
    dispatch(fetchOneSent());
    return UserApiUtils.fetchOne(idOrPermalink).then(
      (data) => dispatch(fetchOneSucceeded(data)),
      (error) => dispatch(fetchOneFailed(error)),
    );
  };
}
